module.exports = __webpack_public_path__ + "8d1acbd66f23cb4a95e164c2f9811066.png";